import React, { useState, useEffect } from "react";
import { SITE_CONFIG } from "../config/siteConfig";
import { scrollToSection } from "../config/utils";
import heroVideo from "../assets/Template_Film_Khass.mp4";

// ══════════════════════════════════════════════════════════════
// ⚠️  À CHANGER : décommentez la ligne ci-dessous pour utiliser
//     votre vidéo. Placez le fichier dans src/assets/
// ══════════════════════════════════════════════════════════════

const VideoHero: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      id="hero"
      className="relative h-screen w-full overflow-hidden bg-black"
    >
      {/* ══════════════════════════════════════════════════════
          ⚠️  VIDÉO DE FOND — À CHANGER
          
          Décommentez le bloc <video> ci-dessous et supprimez
          le bloc "Vidéo placeholder" qui suit.
          
          Assurez-vous d'avoir importé heroVideo en haut du fichier.
      ══════════════════════════════════════════════════════ */}

      
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-0"
      >
        <source src={heroVideo} type="video/mp4" />
      </video> 
     

      {/* ── Vidéo placeholder (supprimer quand vous ajoutez la vraie vidéo) ── */}
      {/* <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse at 60% 40%, #2a1508 0%, #0a0400 40%, #000 80%)",
          }}
        />
        <div
          className="absolute inset-0 opacity-20 animate-hero-pulse"
          style={{
            background:
              "radial-gradient(circle at 30% 60%, #c0392b 0%, transparent 50%)",
          }}
        />
        <div
          className="absolute inset-0 opacity-10 animate-hero-pulse-reverse"
          style={{
            background:
              "radial-gradient(circle at 70% 30%, #BB9D63 0%, transparent 40%)",
          }}
        />
      </div> */}
      {/* ── Fin placeholder ── */}

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/50 z-[1]" />

      {/* Fade to black en bas (identique à votre FadeToBlack original) */}
      <div
        className="absolute bottom-0 w-full h-[20vh] z-[2]"
        style={{
          background: "linear-gradient(to top, black 0%, transparent 100%)",
        }}
      />

      {/* Contenu centré */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <div
          className={`transition-all duration-1000 delay-300 ${
            loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p className="text-amber-600/70 tracking-[0.4em] uppercase text-xs mb-6">
            Photobooth 360° · Événements d'exception
          </p>
        </div>

        <h1
          className={`font-display leading-tight transition-all duration-1000 delay-500 ${
            loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
          style={{
            fontSize: "clamp(2.8rem, 8vw, 6rem)",
            color: "#BB9D63",
            letterSpacing: "-0.02em",
          }}
        >
          {SITE_CONFIG.brand}
        </h1>

        <p
          className={`mt-3 text-lg md:text-2xl font-light tracking-[0.15em] uppercase text-white/70 transition-all duration-1000 delay-700 ${
            loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {SITE_CONFIG.tagline}
        </p>

        <div
          className={`mt-10 flex items-center justify-center gap-4 flex-wrap transition-all duration-1000 delay-1000 ${
            loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <button
            onClick={() => scrollToSection("contact")}
            className="px-10 py-3.5 text-sm tracking-wider uppercase border border-white/30 text-white hover:bg-white/10 transition-all duration-300"
          >
            Contact
          </button>
          <button
            onClick={() => scrollToSection("offers")}
            className="px-10 py-3.5 text-sm tracking-wider uppercase border border-white/30 text-white bg-white/10 hover:bg-white/20 transition-all duration-300"
          >
            Offres
          </button>
        </div>
      </div>

      {/* Indicateur de scroll */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 border border-white/20 rounded-full flex justify-center pt-1.5">
          <div className="w-1 h-2 bg-amber-500/60 rounded-full animate-bounce" />
        </div>
      </div>

      <style>{`
        @keyframes heroPulse {
          0%, 100% { opacity: 0.15; transform: scale(1); }
          50% { opacity: 0.25; transform: scale(1.08); }
        }
        .animate-hero-pulse { animation: heroPulse 10s ease-in-out infinite; }
        .animate-hero-pulse-reverse { animation: heroPulse 8s ease-in-out infinite reverse; }
      `}</style>
    </section>
  );
};

export default VideoHero;
